<script>
	import { onMount } from 'svelte';
	import apiRequest from './api.js';
	import Login from './Login.svelte';
	import NewPin from './NewPin.svelte';

	let loggedIn = false;
	let checkedLoggedIn = false;

	onMount(async () => {
	  const response = await apiRequest('/skewer/user');
	  if (response.ok) {
	    loggedIn = true;
	  }
	  checkedLoggedIn = true;
	});
</script>

<main>
	{#if loggedIn}
		<NewPin/>
	{:else if checkedLoggedIn}
		<Login/>
	{/if}
</main>

<style>
</style>
